import api from './client';

// #Fase3-A2 — Reutiliza autenticación y alcance del cliente HTTP existente.
export const providersAPI = {
  list: (params) => api.get('/providers', { params }),
  get: (id) => api.get(`/providers/${id}`),
  create: (data) => api.post('/providers', data),
  update: (id, data) => api.put(`/providers/${id}`, data),
  archive: (id) => api.post(`/providers/${id}/archive`),
  forEvent: (id) => api.get(`/events/${id}/providers`),
  assign: (id, data) => api.post(`/events/${id}/providers`, data),
  updateAssignment: (id, data) => api.put(`/event-providers/${id}`, data),
  removeAssignment: (id) => api.delete(`/event-providers/${id}`),
};

export const findingsAPI = {
  list: (params) => api.get('/findings', { params }),
  get: (id) => api.get(`/findings/${id}`),
  create: (data) => api.post('/findings', data),
  action: (id, data) => api.post(`/findings/${id}/actions`, data),
  propose: (id) => api.post(`/findings/${id}/propose`),
  validate: (id, data) => api.post(`/findings/${id}/validate`, data),
  reopen: (id) => api.post(`/findings/${id}/reopen`),
  evidence: (id, file, metadata) => {
    const form = new FormData();
    form.append('file', file);
    Object.entries(metadata).forEach(([key, value]) => {
      if (value != null) form.append(key, value);
    });
    return api.post(`/findings/${id}/evidence`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export const dossierAPI = { get: (id) => api.get(`/events/${id}/dossier`) };
export const incidentsAPI = {
  evidence: (id, file, metadata = {}) => {
    const form = new FormData();
    form.append('file', file);
    Object.entries(metadata).forEach(([key, value]) => {
      if (value != null) form.append(key, value);
    });
    return api.post(`/incidents/${id}/evidence`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  update: (id, data) => api.patch(`/incidents/${id}`, data),
  list: (params) => api.get('/incidents', { params }),
  create: (data) => api.post('/incidents', data),
  toFinding: (id) => api.post(`/incidents/${id}/to-finding`),
};
